import React, { useEffect, useState } from 'react'
import CamposTransferencia from './CamposTransferencia'
import { FORM_TRANSFERENCIAS_EXPORTADOR } from '../../../../../config/forms'
import { reduxForm } from 'redux-form'

function EdicionTransferencia (props) {
  const { detalle, change: formChange } = props
  const [precarga, setPrecarga] = useState(false)

  useEffect(() => {
    if (!precarga) {
      formChange('fecha', detalle.fecha)
      formChange('exportadorOrigen', detalle.exportadorOrigen)
      formChange('exportadorDestino', detalle.exportadorDestino)
      formChange('cerealVariedad', detalle.cerealVariedad)
      formChange('cantidad', detalle.cantidad)
      formChange('cereal', detalle.cereal)
      setPrecarga(true)
    }
  }, [detalle, formChange, precarga])

  return (
    <>
      <CamposTransferencia cerealInicial={detalle.cereal} />
    </>
  )
}

const withReduxForm = reduxForm({
  form: FORM_TRANSFERENCIAS_EXPORTADOR,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withReduxForm(EdicionTransferencia)
